import { gql } from '@apollo/client';
import { Schema } from './schema';

export const MASTERS_FOR_CREATE_REPORT = gql`
  query mastersForCreateReport {
    client {
      id
      offices {
        id
        name
        socialContactInfo {
          ...LmsOfficeContactInfo
        }
        laborContactInfo {
          ...LmsOfficeContactInfo
        }
        ownerContactInfo {
          ...LmsOfficeContactInfo
        }
        laborInsuranceNumber0
        laborInsuranceNumber1
        laborInsuranceNumber2
        laborInsuranceNumber3
        laborInsuranceNumber4
        laborStandardsInspectionOfficeL {
          id
          shortName
        }
      }
    }
    businessTypes {
      id
      name
    }
    prefectures {
      id
      name
    }
  }

  fragment LmsOfficeContactInfo on LmsOfficeContactInfo {
    id
    name
    postcode0
    postcode1
    prefecture {
      id
    }
    city
    houseNumber
    building
    phoneNumber0
    phoneNumber1
    phoneNumber2
    repPositionName
    repLastName
    repFirstName
  }
`;

export interface MastersForCreateReportQueryResult {
  client: {
    id: string;
    offices: Office[];
  };
  businessTypes: BusinessType[];
  prefectures: Prefecture[];
}

export interface Office {
  id: string;
  name: string;
  socialContactInfo?: LmsOfficeContactInfo;
  laborContactInfo?: LmsOfficeContactInfo;
  ownerContactInfo?: LmsOfficeContactInfo;
  laborInsuranceNumber0?: string;
  laborInsuranceNumber1?: string;
  laborInsuranceNumber2?: string;
  laborInsuranceNumber3?: string;
  laborInsuranceNumber4?: string;
  laborStandardsInspectionOfficeL?: LmsGovernmentOffice;
}

export interface LmsOfficeContactInfo {
  id: string;
  name?: string;
  postcode0?: string;
  postcode1?: string;
  prefecture?: {
    id: string;
  };
  city?: string;
  houseNumber?: string;
  building?: string;
  phoneNumber0?: string;
  phoneNumber1?: string;
  phoneNumber2?: string;
  repPositionName?: string;
  repLastName?: string;
  repFirstName?: string;
}

export interface LmsGovernmentOffice {
  id: string;
  shortName: string;
}

export interface BusinessType {
  id: string;
  name: string;
}

export interface Prefecture {
  id: string;
  name: string;
}

export const CREATE_REGULAR_HEALTH_CHECKUP_REPORT = gql`
  mutation createRegularHealthCheckupReport($input: CreateRegularHealthCheckupReportInput!) {
    createRegularHealthCheckupReport(input: $input) {
      regularHealthCheckupReport {
        id
      }
    }
  }
`;

export interface CreateRegularHealthCheckupReportQueryVariables {
  input: {
    attributes: {
      title: string;
      officeId?: string;
      officeSnapshot?: {
        name?: string;
        postcode0?: string;
        postcode1?: string;
        prefectureId?: string;
        city?: string;
        houseNumber?: string;
        building?: string;
        phoneNumber0?: string;
        phoneNumber1?: string;
        phoneNumber2?: string;
        laborInsuranceNumber0?: string;
        laborInsuranceNumber1?: string;
        laborInsuranceNumber2?: string;
        laborInsuranceNumber3?: string;
        laborInsuranceNumber4?: string;
        repPositionName?: string;
        repLastName?: string;
        repFirstName?: string;
        laborStandardsInspectionOfficeLShortName?: string;
      };
      businessTypeId?: string;
      startOn?: string;
      endOn?: string;
      reportNumber?: number;
      aggregationOfficeIds?: string[];
    };
  };
}

export interface CreateRegularHealthCheckupReportQueryResult {
  createRegularHealthCheckupReport: {
    regularHealthCheckupReport: {
      id: string;
    };
  };
}

export const convertFormDataToQueryVariables = (data: Schema): CreateRegularHealthCheckupReportQueryVariables => {
  return {
    input: {
      attributes: {
        title: data.title,
        officeId: data.officeId,
        officeSnapshot: data.officeSnapshot,
        businessTypeId: data.businessTypeId,
        startOn: data.startOn,
        endOn: data.endOn,
        reportNumber: data.reportNumber ? parseInt(data.reportNumber, 10) : undefined,
        aggregationOfficeIds: data.aggregationOfficeIds
      }
    }
  };
};
